import { Checkbox, FormControlLabel, Radio, RadioGroup, styled } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { isEqual } from "lodash";
import Input, { DashboardCheckbox, DashboardSelect } from "../Input/InputNew";
import { getMetaData, getNewConfiguration } from "../../services/uiConfigService";
import QuestionHeading from "../heading/QuestionHeading";
import { UiConfigImageUpload } from "./UiConfigImageUpload";
import { HexColorPicker } from "react-colorful";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeDropper } from '@fortawesome/free-solid-svg-icons';
import { KeyValueTile } from "../../features/filterLabel/FilterLabel";
import { IndentWrapper } from "../../features/orderConfiguration/OrderConfiguration";
import { defaultOrderTrackingSupportValues } from "../constants/uiConfigConstants";
import { orderTrackingStageType, stageType } from "../../types";

  export const RelatedDashboardSelect = (props: any) => {
    const [selectedOptions, setSelectedOptions] = useState<any>({});
    const handleOptionChange = (elementId:any, value:any) => {
      setSelectedOptions((prevState:any) => ({
          ...prevState,
          [elementId]: value
      }));
  };
  useEffect(()=>{
    // debugger
    const fetchData = async () => {
      const filterResp = await getNewConfiguration('tab_filters');
      const filters=filterResp.domainValues?.[0].value;
      if (filters) {
        setSelectedOptions({
              filter1: filters?.[0]?.name ? filters?.[0]?.name:'none',
              filter2: filters?.[1]?.name ? filters?.[1]?.name:'none',
              filter3: filters?.[2]?.name ? filters?.[2]?.name:'none',
          })
      }
    }
    fetchData();
  },[])
  console.log("selectedOptions",selectedOptions)
    return (
    <div>
        {props.element?.relatedElements?.elements && props.element?.relatedElements?.elements.map((element: any, index: any) => {
          const disabled =
            index > 0 &&
            Array.from({ length: index }).some((_, i) => selectedOptions[props.element.relatedElements.elements[i].elementId] === 'none');
  
          return (
            <div key={element.elementId}>
              <QuestionHeading>{element.heading}</QuestionHeading>
              <div className="answer_container">
                <FormControl margin="dense" style={{ minWidth: "32%" }}>
                  <Select
                    disabled={disabled}
                    id={element.elementId}
                    name={element.elementId}
                    onChange={(e) => handleOptionChange(element.elementId, e.target.value)}
                    value={selectedOptions[element.elementId] || ''}
                  >
                     {props.element.relatedElements.optionConfig.options.map((option:any) => (
                              (!Object.values(selectedOptions).includes(option.value) || selectedOptions[element.elementId] === option.value || option.value==="none" ) && (
                                <MenuItem value={option.value}>
                                <span className="first_letter_capital">{option.title}</span>
                              </MenuItem>
                              )
                          ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  
  export const MultiCheckBox = (props: any) => {
    const [checkedOptions, setCheckedOptions] = useState(() => {
      const prevCheckedValues = props.values[props.name]?.value || [];
      return prevCheckedValues.map((option: any) => ({
        ...props.value,
        ...option
      }));
    });
    const handleCheckboxChange = (event:any, option:any) => {
      const isChecked = event.target.checked;
      if (isChecked) {
        setCheckedOptions((prevCheckedOptions:any) => [...prevCheckedOptions, option]);
      } else {
        setCheckedOptions((prevCheckedOptions:any) =>
          prevCheckedOptions.filter((checkedOption:any) => checkedOption[props.element?.key] !== option[props.element?.key])
        );
      }
    };
    useEffect(() => {
      const prevCheckedValues = props.values[props.name]?.value || [];
      const newCheckedOptions = prevCheckedValues.map((option:any) => ({ ...props.value, ...option }));
      if (!isEqual(newCheckedOptions, checkedOptions)) {
        setCheckedOptions(newCheckedOptions);
      }
    }, [props.values]);
    useEffect(() => {
      props.setValues((prev:any) => ({
        ...prev,
        [props.name]: {
          ...prev[props.name],
          value: checkedOptions
        }
      }));
    }, [checkedOptions, props.name]);
  
    return (
      <>
        {props.element?.checkboxOptions &&
          props.element?.checkboxOptions.map((option: any) => (
            <span
              key={option[props.element?.key]}
              style={{
                fontSize: "1.1rem",
                display: "inline-flex",
                justifyContent: "flex-start",
                alignItems: "center"
              }}
            >
              <Checkbox
              id={option[props.element?.key]}
              defaultChecked={option.checked}
              checked={checkedOptions.some((checkedOption:any) => checkedOption[props.element?.key] === option[props.element?.key])}
              size="medium"
              onChange={(event) => handleCheckboxChange(event, option)}
              name={option[props.element?.key]}
            />
  
              {option[props.element?.key]}
            </span>
          ))}
      </>
    );
  };
  
  
  export const MultiImage = (props: any) => {
    useEffect(() => {
      const newValues = [...props.values[props.name].value]; 
      if (newValues.length !== props?.extendedAttributes?.numberOfimg) {
        const initialValue = Array.from(
          { length: props?.extendedAttributes?.numberOfimg - newValues.length },
          () => ""
        );
        newValues.push(...initialValue);
        props.setValues((prev:any) => {
          const newVal = {
            ...prev,
            [props.name]: {
              ...prev[props.name],
              value: newValues,
            },
          };
          if (!isEqual(prev, newVal)) {
            return newVal;
          } else {
            return prev;
          }
        });
        console.log("props.values", props.values);
      }
  }, [props.values[props.name].value]);
    return (
      <div>
      <span className="resolution_text" style={{
          display: "flex",
          width: "100%",
          marginLeft: "1.5rem",
          marginTop: "1.5rem"
      }}>*The {props?.extendedAttributes?.max ? "maximum": ""}  image resolution should be {props.extendedAttributes?.width}X{props.extendedAttributes?.height}</span>
      <div className="answer_container" style={{ width: "100%" }}>
          {props.values[props.name]?.value?.map((blobKey: any, index: number) => (
              <div key={index} className="image-list-item">
                  <UiConfigImageUpload
                      list={true}
                      resolution={{
                          height: Number(props.extendedAttributes?.height),
                          width: Number(props.extendedAttributes?.width)
                      }}
                      label={props.extendedAttributes?.label}
                      defaultFile={blobKey}
                      setDefaultFile={(blobKey: any) => props.handleImageListChange(index, blobKey)}
                      accept={{
                          image: ["png", "jpeg", "jpg"]
                      }}
                      max={props?.extendedAttributes?.max}
                      fetchBlobKey={true}
                      errorMessage={!blobKey ? "Please upload Image" : ""}
                  />
              </div>
          ))}
      </div>
  </div>
    );
  };
  
  export const CustomSelect = (props:any) => {
    const [options,setOptions]=useState(props?.extendedAttributes?.optionConfig?.options)
  
    const handleChange = (name:any, value:any) => {
      const updatedValues=props.updateState(name,value,props.values);
      props.setValues(updatedValues);
      
     
  };
  
  useEffect(() => {
    const fetchData = async () => {
      if(props.extendedAttributes?.optionConfig?.fetchType==="config"){
        const configResp = await getNewConfiguration(props.extendedAttributes?.optionConfig?.source);
        const optionList:string[]=[];
        const configValues = configResp && configResp["domainValues"].find((config:any) => config.name === props.extendedAttributes?.optionConfig?.configName);
        if (configValues && configValues.value && configValues.value.length > 0) {
          configValues.value.forEach((option: { [key: string]: string }) => {
              const key = props.extendedAttributes?.optionConfig?.key;
              if (key && option[key]) {
                  optionList.push(option[key]);
              }
          });
          const formattedOptions = optionList.map(value => ({ value, "title" : value }));
          setOptions(formattedOptions)
      }
      }
      
      if(props.extendedAttributes){
        setOptions(props.extendedAttributes);
      }
    }
    fetchData();
  }, [props.values[props.name]]);
 
    return (
        <div className="answer_container_new">
            <DashboardSelect
                onChange={(e) => { handleChange(e.target.name, e.target.value) }}
                value={props.values[props.name]?.value}
                name={props.name}
                options={options ?? []}
                selectLableId={props.extendedAttributes?.lableId ?? ""}
                disabled={props?.extendedAttributes?.optionConfig?.disabled??false}
            />
        </div>
    );
  };


  export const CustomRadio=(props:any)=>{
     const [options,setOptions]=useState(props?.extendedAttributes)
      const [selectedValue, setSelectedValue] = useState<string>('');
      const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedValue(event.target.value);
      const updatedValues=props.updateState(props.name,event.target.value,props.values);
      props.setValues(updatedValues);
    };
     
    useEffect(()=>{
      if(props.extendendAttributes) setOptions(props.extendedAttributes)
    },[])
    return (
      <div className="answer_container_new">
      <RadioGroup
        row
        name={props.name}
        value={selectedValue}
        onChange={handleChange}
      >
        {options.map((opt: any) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio />}
            label={opt.label}
          />
        ))}
      </RadioGroup>
    </div>
    )
  }




  interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    callback?: Function
  }
  const Picker = (props: WrapperProps) => {
    const Wrapper = styled('span')(`
      width:2.5rem!important;
      padding-top:1rem;
      padding-bottom:1rem;
      border:#a2a9b0 solid 1px;
      display:flex;
      justify-content:center;
      align-items:center;
      border-radius:0.15rem
      `)
    return <Wrapper {...props}><FontAwesomeIcon color='#a2a9b0' icon={faEyeDropper} /></Wrapper>
  }
  const showColorStyle = (color: string) => { return { backgroundColor: color ? color.includes("#") ? color : "#" + color : "transparent", width: "3rem", height: "1.8rem", borderRadius: '0.2rem', marginLeft: '1rem', marginBottom:"13.5px" ,
   } }

  export const ColorPicker = (props:any) => {
    const [currentColor, setCurrentColor] = useState(props?.values[props?.name]?.value);
    const [showColorPicker, setShowColorPicker] = useState(false);
  
    const handleInputChange = (e: { target: { value: any; }; }) => {
      setCurrentColor(e.target.value);
    };
  
    const toggleColorPicker = () => {
      setShowColorPicker(!showColorPicker);
    };

    useEffect(() => {
      const prevCheckedValues = props?.values[props?.name]?.value || [];
      if (!isEqual(prevCheckedValues, currentColor)) {
        setCurrentColor(props?.values[props?.name]?.value)
      }
      }, [props?.values]);

    useEffect(() => {
  const timeout = setTimeout(() => {
   const updatedValues= props.updateState(props.name,currentColor,props.values)
    props.setValues(updatedValues)
  }, 300); 
  return () => clearTimeout(timeout);
}, [currentColor]);


    return (
        <div className="color_picker_containernew"  >
        {showColorPicker ? (
          <div  >
            <HexColorPicker color={currentColor} onChange={setCurrentColor} />
             <Input 
                  
                      value={currentColor}
                      onChange={handleInputChange}
                      inputProps={{ maxLength: 7 }}
                    />
          </div>
        ) : (
          <span style={{ width: "60%" }}>
            <Input
              value={currentColor}
              onChange={handleInputChange}
              inputProps={{ maxLength: 7 }}
              name={props.name}
            />
          </span>
        )}
        <Picker style={showColorStyle(currentColor)} onClick={toggleColorPicker} />
        </div>
    );
  };
  
  export const LabelInput = (props: any) => {
    return (
    <div>
       {
            Object.keys(props.values[props.name].value)?.map((key, index) => {
                return <KeyValueTile label={key} values={props.values} setValues={props.setValues} />
            })
        }

    </div>
    );
  };
  
  export const Track = (props: any) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState<number | null>(null);
  
    const toggleColorPicker = (index: number) => {
      setSelectedItemIndex(selectedItemIndex === index ? null : index);
    };
  
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
      const newValue = [...props.values?.[props.name]?.value];
      newValue[index].label = e.target.value;
      props.setValues({
        ...props.values,
        [props.name]: {
          ...props.values?.[props.name],
          value: newValue
        }
      });
    };
  
    return (
      <div>
        {props?.values?.[props.name]?.value && props?.values?.[props.name]?.value?.map((stage: any, index: number) => (
          <>
            <div className="answer_container" key={index}>
              {stage.name}
            </div>
            <IndentWrapper indent={2}>
              <QuestionHeading>Write Label</QuestionHeading>
              <div className="answer_container">
                <Input
                  name={stage.label}
                  value={stage.label}
                  onChange={(e) => handleValueChange(e, index)}
                />
              </div>
              <QuestionHeading>Write Hex Code</QuestionHeading>
              <div className="color_picker_container" style={{ padding: "0.7rem" }}>
                {selectedItemIndex === index && (
                  <div>
                    <HexColorPicker color={stage.color} onChange={(color) => {
                      const newValue = [...props.values[props.name].value];
                      newValue[index].color = color;
                      props.setValues({
                        ...props.values,
                        [props.name]: {
                          ...props.values[props.name],
                          value: newValue
                        }
                      });
                    }} />
                    <Input
                      value={stage.color}
                      onChange={(e) => {
                        const newValue = [...props.values[props.name].value];
                        newValue[index].color = e.target.value;
                        props.setValues({
                          ...props.values,
                          [props.name]: {
                            ...props.values[props.name],
                            value: newValue
                          }
                        });
                      }}
                      inputProps={{ maxLength: 7 }}
                    />
                  </div>
                )}
                {selectedItemIndex !== index && (
                  <span style={{ width: "60%" }}>
                    <Input
                      value={stage.color}
                      onChange={(e) => {
                        const newValue = [...props.values[props.name].value];
                        newValue[index].color = e.target.value;
                        props.setValues({
                          ...props.values,
                          [props.name]: {
                            ...props.values[props.name],
                            value: newValue
                          }
                        });
                      }}
                      inputProps={{ maxLength: 6 }}
                      name={props.name}
                    />
                  </span>
                )}
                <Picker style={showColorStyle(stage.color)} onClick={() => toggleColorPicker(index)} />
              </div>
            </IndentWrapper>
          </>
        ))}
      </div>
    );
  };

 
  const OrderTrackingStageInput = (props: any) => {
    const { setOrderTrackingStagesValues, OrderTrackingStagesValues, stage, index } = props;
    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const arr = [...OrderTrackingStagesValues];
        arr[index].value = !arr[index].value;
        setOrderTrackingStagesValues(arr);
    }
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const arr = [...OrderTrackingStagesValues];
        arr[index].label = e.target.value;
        setOrderTrackingStagesValues(arr);
    }
    const handleColorInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const arr = [...OrderTrackingStagesValues];
        arr[index].color = e.target.value;
        setOrderTrackingStagesValues(arr);
    }
    return <><div className={"generic_form_container even_container"}>
        <DashboardCheckbox onChange={handleCheckChange} checked={OrderTrackingStagesValues?.[index]?.value} label={OrderTrackingStagesValues[index]?.id} />
    </div>
        {OrderTrackingStagesValues[index]?.value && <>
            <IndentWrapper indent={2}>
                <QuestionHeading>
                    Write Label
                </QuestionHeading>
                <div className="answer_container">
                    <Input name={stage.status} value={OrderTrackingStagesValues?.[index]?.label} onChange={handleValueChange} />
                </div>
            </IndentWrapper>
            <IndentWrapper indent={2}>
                <QuestionHeading>
                    Write hex code
                </QuestionHeading>
                <div className="answer_container">
                    <Input value={OrderTrackingStagesValues?.[index]?.color} inputProps={{ maxLength: 7 }} onChange={handleColorInputChange} />
                </div>
            </IndentWrapper>
        </>
        }
    </>
}

  export const TrackOrder = (props: any) => {
    const [orderTrackingStages, setOrderTrackingStages] = useState<orderTrackingStageType[]>([]);
    const [orderTrackingStagesValues, setOrderTrackingStagesValues] = useState<stageType[]>([]);
    const prevValuesRef = useRef<any[]>([]);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          let orderTrackingResp: orderTrackingStageType[] = await getMetaData("supportedValues", "OrderDetails-status");
          const result: { id: string, color: string, label: string, value: boolean }[] = [];

          if(orderTrackingResp===undefined){
              orderTrackingResp=defaultOrderTrackingSupportValues;
          }
          setOrderTrackingStages(orderTrackingResp)
          orderTrackingResp.forEach((stage) => {
              const obj = {
                  id: stage.status,
                  color: '',
                  label: '',
                  labelColor: '',
                  value: false,
              };
              result.push(obj)
          })
          setOrderTrackingStagesValues(result);
        } catch (error) {
          console.error('Error fetching order tracking data:', error);
        }
      };
      fetchData();
    }, []);
    useEffect(() => {
      if (props.values[props.name].value?.length) {
        const updatedOrderTracking = orderTrackingStagesValues.map(itemA => {
            const matchedItemB = props.values[props.name].value.find(((itemB: { id: string; }) => itemB.id.toLowerCase() === itemA.id.toLowerCase()));
            return matchedItemB ? { ...itemA, ...matchedItemB, value: true } : itemA;
        });
        setOrderTrackingStagesValues(updatedOrderTracking);
    }
    }, [props.values[props.name].value]);

    const updateValues = useCallback(() => {
      const filteredOrderTrackingStages = orderTrackingStagesValues.filter(item => item.value);
      const finalOrderTrackingStagesValues = filteredOrderTrackingStages.map(({ value, ...rest }) => rest);
  
      if (JSON.stringify(finalOrderTrackingStagesValues) !== JSON.stringify(prevValuesRef.current)) {
        props.setValues({
          ...props.values,
          [props.name]: {
            ...props.values[props.name],
            value: finalOrderTrackingStagesValues
          }
        });
        prevValuesRef.current = finalOrderTrackingStagesValues;
      }
    }, [orderTrackingStagesValues]);
  
    useEffect(() => {
      updateValues();
    }, [orderTrackingStagesValues, updateValues]);
   
    return (
      <div>
          {
        orderTrackingStages?.map((stage, index) => {
          return <OrderTrackingStageInput index={index} stage={stage} OrderTrackingStagesValues={orderTrackingStagesValues} setOrderTrackingStagesValues={setOrderTrackingStagesValues} />
        })
      }
      </div>
    );
  };